import styled from 'styled-components'
import { ResponsiveImage } from '../../ResponsiveImage/ResponsiveImage'

export const BlocksGrid = styled.div`
  display: grid;
  grid-auto-columns: 1fr 1fr;
  grid-template-columns: 1fr;
  gap: 0.8rem;

  @media screen and (min-width: 768px) {
    grid-auto-columns: 1fr;
    grid-template-columns: 1fr 1fr;
  }
`

export const StyledResponsiveImage = styled(ResponsiveImage)`
  height: 100%;
  object-fit: cover;
`
